import * as React from "react";
import { forwardRef } from "react";
const SvgStarFull = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 64 61",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "m62 21.4-19.3-2.8-8.5-17.3c-.3-.4-.7-.8-1.1-1a2.4 2.4 0 0 0-3.3 1l-8.5 17.3L2 21.4A2.4 2.4 0 0 0 0 23.8c0 .7.3 1.3.7 1.7l14 13.5-3.4 19a2.4 2.4 0 0 0 2.2 2.8c.5 0 1 0 1.3-.3l17.2-9 17.2 9a2.4 2.4 0 0 0 3.5-2.5l-3.3-19 13.9-13.5a2.4 2.4 0 0 0-1.4-4Z",
	fill: "currentColor"
}));
const ForwardRef = forwardRef(SvgStarFull);
export default ForwardRef;
